// @ts-nocheck

import React, { Component } from 'react';
import { connect } from 'react-redux';
import notification from 'antd/lib/notification';
import { navigate } from '../../lib/routerAdapter';
import styled from 'styled-components';

import type { Contractor } from '../../lib/types/contractor';
import {
  fetchContractor,
  cleanContractor,
  updateContractor,
  addContractor
} from '../../ducks/contractor';
import type { AppState } from '../../ducks/redux';
import { Panel } from './../../components/layout';
import InnerForm from './components/InnerForm';
import Breadcrumbs, { Crumb } from '../../components/layout/Breadcrumbs';
import Header from '../../components/layout/Header';
import { notificationLoading } from './../../components/Notifications';

const StyledPanel = styled(Panel)`
  padding-top: 0;
`;

const notificationWithDestroy = notification as typeof notification & {
  destroy: (key: string) => void;
};

const getErrorMessage = (error: unknown) =>
  error instanceof Error ? error.message : String(error);

type Props = {
  contractor: Contractor | null,
  fetchContractor: (id: number) => Promise<void>,
  updateContractor: (contractor: Contractor) => Promise<void>,
  addContractor: (contractor: Contractor) => Promise<void>,
  cleanContractor: () => unknown,
  contractorId: number
};

export class Form extends Component<Props> {
  async componentDidMount() {
    const { contractorId } = this.props;
    if (contractorId) {
      try {
        await this.props.fetchContractor(contractorId);
      } catch (error) {
        notification.error({
          message: 'Ошибка',
          description: getErrorMessage(error)
        });
        navigate('/admin/contractors');
      }
    }
  }

  componentWillUnmount() {
    this.props.cleanContractor();
  }

  onCancel = () => {
    navigate('/admin/contractors');
  };

  onSubmit = async (contractor: Contractor) => {
    try {
      notificationLoading({
        message: 'Сохранение данных...',
        key: 'saving'
      });
      if (contractor.id) {
        await this.props.updateContractor(contractor);
        notification.success({
          message: 'Успешное обновление',
          description: 'Данные были успешно обновлены'
        });
      } else {
        await this.props.addContractor(contractor);
        notification.success({
          message: 'Успешное добавление',
          description: `Подрядчик успешно добавлен`
        });
      }
      navigate('/admin/contractors');
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: getErrorMessage(error)
      });
    } finally {
      notificationWithDestroy.destroy('saving');
    }
  };

  render() {
    const { contractor } = this.props;
    return (
      <>
        <Header
          left={
            <Breadcrumbs>
              <Crumb to="/">Главная</Crumb>
              <Crumb to="/admin/contractors">Подрядчики</Crumb>
              {contractor ? (
                <>
                  <Crumb to={`/admin/contractors/${contractor.id}`}>
                    {contractor.name}
                  </Crumb>
                </>
              ) : (
                <Crumb to="/admin/contractors/new">Новый подрядчик</Crumb>
              )}
            </Breadcrumbs>
          }
        />
        <StyledPanel>
          <h1>
            {contractor ? `Подрядчик №${contractor.id}` : 'Новый подрядчик'}
          </h1>
        </StyledPanel>
        <InnerForm
          contractor={contractor}
          onSubmit={this.onSubmit}
          onCancel={this.onCancel}
        />
      </>
    );
  }
}

export default connect(
  (state: AppState, props: { contractorId: string }) => ({
    contractor: state.contractor,
    contractorId: parseInt(props.contractorId, 10)
  }),
  {
    fetchContractor,
    updateContractor,
    cleanContractor,
    addContractor
  }
)(Form);
